export default {
  'categories.title': '分类',
  'categories.edit.copy': '单击任一分类进行编辑',
  'categories.action.add': '新建分类',
  'categories.edit.title': '编辑分类',

  'categories.section.generalInfo': '基本信息',
  'categories.column.name': '分类名',
  'categories.column.foreign_name': '分类中文名',
  'categories.column.tax_code': '税码',
  'categories.column.sales_category': '销售分类',
  'categories.column.description': '描述',
  'categories.column.add': '新增',
  'categories.column.category_name.required': '分类名必填',
  'categories.column.has_limited_availability': '是否限制可用性',
  'categories.column.has_limited_availability.tooltip':
    '当此选项开启时，此分类始终可见；当此选项关闭时，此分类仅在其关联的时间内可见',
  'categories.column.name.required': '分类名必填',
  'categories.column.foreign_name.required': '分类中文名必填',

  'categories.column.posName': 'POS别名',
  'categories.column.kitchenName': '后厨别名',
  'categories.column.posName.placeholder': '点餐页上展示的名字',
  'categories.column.kitchenName.placeholder': '在后厨单和标签上展示的名字',
  'categories.column.posName.tooltip': '别名可以是短名或缩写，区分大小写，并在点餐页上展示的名字',
  'categories.column.kitchenName.tooltip': '别名可以是短名或缩写，区分大小写，并在后厨单和标签上展示的名字',

  'categories.column.is_point': '是否是积分菜类目',
  'categories.column.is_point.tooltip': '当此选项开启时，此分类为积分菜类目，这个类目下的菜品都需要设置积分属性',

  'categories.pointCategory.postfix': '积分',
};
